import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/main-component/App/App';
import reportWebVitals from './reportWebVitals';
import GlobalAOSProvider from './GlobalAOSProvider/GlobalAOSProvider ';
import '../node_modules/react-modal-video/scss/modal-video.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './css/fontawesome.css';
import './css/themify-icons.css';
import './css/animate.min.css';
import './css/cursor.css';
import './css/style.css';
import './components/ContactSection/contactform.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GlobalAOSProvider>
        <App />
    </GlobalAOSProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
